module.exports = __webpack_public_path__ + "img/flowNews.056a8a7b.svg";